import axiosClient from './axios-client';

const getUserInfo = async (userId) => axiosClient.get(`ifincredit/users/${userId}`);

const userApi = {
  getUserInfo
}

export default userApi;
